import React from "react";
import { Link } from "gatsby";

const LinkOrAOrText = ({
  anchor,
  to,
  href,
  className,
  rel,
}: {
  anchor: string;
  to?: string;
  href?: string;
  className?: string;
  rel?: string;
}) => (
  <>
    {to ? (
      <Link to={to} className={className}>
        {anchor}
      </Link>
    ) : href ? (
      <a className={className} rel={rel ? "noopener noreferrer " + rel : "noopener noreferrer"} href={href}>
        {anchor}
      </a>
    ) : (
      <span className={className}>{anchor}</span>
    )}
  </>
);

export default LinkOrAOrText;
